import React from 'react';
import { forEach } from 'lodash';
import Log, { LogContext } from './Log';
import { sendLog } from './utils';

function getEventHandlers(child, consumedProps, actionProps) {
	const eventHandlers = {};
	forEach(actionProps, (specificHandlerProps, eventHandlerName) => {
		eventHandlers[eventHandlerName] = (...eventHandlerArgs) => {
			child.props[eventHandlerName]?.apply(child, eventHandlerArgs);
			sendLog({ ...consumedProps, ...specificHandlerProps });
		};
	});
	return eventHandlers;
}

export default function LogEvent(props) {
	const { elementType, actionProps, logEventProps, children } = props;
	if (!logEventProps || !actionProps) { return children; }
	return (
		<Log elementType={elementType} {...logEventProps}>
			<LogContext.Consumer>
				{(consumedProps) =>
				React.Children.map(children, (child) =>
					child ? React.cloneElement(child, getEventHandlers(child, consumedProps, actionProps)) : null				)}
			</LogContext.Consumer>
		</Log>
	);
}
